var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpDownIconV1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "up-down-icon",
    width: 28,
    height: 50,
    viewBox: "0 0 28 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0709 16.3562C25.8321 17.6036 23.8235 17.6036 22.5847 16.3562L14 7.7117L5.41529 16.3562C4.17647 17.6036 2.16794 17.6036 0.929119 16.3562C-0.309704 15.1087 -0.309704 13.0862 0.929119 11.8388L11.7569 0.935581C12.9957 -0.311867 15.0043 -0.311867 16.2431 0.935581L27.0709 11.8388C28.3097 13.0862 28.3097 15.1087 27.0709 16.3562Z",
    fill: "#4DFC3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 50C12.2478 50 10.8275 48.5699 10.8275 46.8057V3.49109C10.8275 1.72693 12.2478 0.296799 13.9998 0.296799C15.7517 0.296799 17.172 1.72693 17.172 3.49109V46.8057C17.172 48.5699 15.7517 50 13.9998 50Z",
    fill: "#4DFC3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownIconV1);
export default __webpack_public_path__ + "static/media/up-down-icon_v1.01a99f8410dc118ce9aba00c49445509.svg";
export { ForwardRef as ReactComponent };